

















import { Component, Prop, Vue } from "vue-property-decorator";
import {
  GetStoreSensorsResponse,
  GetStoresResponse
} from "@/typescript/api_client/emesh_api/stores/types";
import { getStoresApi } from "@/typescript/api_client/emesh_api/stores/stores_api";
export { GetStoreSensorsResponse, GetStoresResponse };
const iconBasePath: string = "/images/icons";

@Component
export default class SidebarContentHeaderComponent extends Vue {
  @Prop({
    default: false
  })
  isCancelArea!: boolean;

  @Prop({
    default: true
  })
  isApiData!: boolean;

  lteSensitivity: number = 0;

  created() {
    this.setApiData();
  }

  async setApiData() {
    if (!this.isApiData) return;
    const storeId = this.$route.params.store_id;
    const store = (await getStoresApi(storeId).catch(() => {
      this.$router.push("/not_found");
    })) as GetStoresResponse;
    // null の場合はアイコンを without にしたいため、 -100 を代入する
    this.lteSensitivity =
      store.receive_sensitivity === null ? -100 : store.receive_sensitivity;
    this.$store.commit("setStoreInfo", {
      storeId: store.store_id,
      storeName: store.store_name,
      storeIsRemoval: store.working_state === 2
    });
  }

  getLTEIcon(sensitivity: number): string {
    // SDRS_EMESH/docs/仕様/フロントエンド仕様書.adoc に基づき、実装する
    if (sensitivity > -75) return `${iconBasePath}/ic_common_lte-max.png`;
    if (sensitivity >= -85) return `${iconBasePath}/ic_common_lte-nomal.png`;
    if (sensitivity >= -95) return `${iconBasePath}/ic_common_lte-weak.png`;
    return `${iconBasePath}/ic_common_lte-without.png`;
  }
}
